<template>
	<div>
		<button class="better-mobile-btn" v-on:click="startScanning" :class="rfid ? 'grey-background' : ''">
			<HandIcon/>
			{{ rfid ? "Re-Scan Wristband" : "Scan Wristband" }}
		</button>

		<div v-if="scanningRfid" class="fullscreen-overlay">
			<h2 class="overlay-header">{{ user_name }}</h2>

			<div class="overlay-body">
				<h5 class="p-05">{{ credential_title }}</h5>

				<div>
					<div v-if="awaitingScan" class="p-05">
						<LoadingDots/>
						<p>Press the RFID against the reader</p>
					</div>

					<p v-else>Place the wristband on the patron and press the button below</p>

					<div class="p-05">
						<button
							:disabled="awaitingScan"
							class="better-mobile-btn"
							v-on:click="complete">
							{{ awaitingScan ? "Scanning RFID..." : "Placed Wristband on Patron" }}
						</button>
					</div>

					<div v-if="isTesting && awaitingScan" class="p-05">
						<button
							class="better-mobile-btn"
							v-on:click="addFakeRFID">
							Add Fake TEST RFID
						</button>
					</div>
				</div>

				<div class="p-1">
					<button class="better-mobile-btn red" v-on:click="back">Back</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import HandIcon from "./icons_svg/HandIcon.vue";
import LoadingDots from "./icons_svg/LoadingDots.vue";

export default {
	name: 'ScanRFIDButton',
	inject: ['rfidService'],
	components: {
		HandIcon,
		LoadingDots
	},
	props: {
		user_name: {
			type: String,
			required: true
		},
		credential_title: {
			type: String,
			required: true
		},
		initial_value: {
			type: String,
			default: ""
		},
	},
	data() {
		return {
			shouldEmit: false,
			rfid: this.initial_value,
			scanningRfid: false,
			awaitingScan: true,
		}
	},
	computed: {
		isStagingSite() {
			return process.env.VUE_APP_API_SERVER.indexOf("staging") >= 0
		},
		isTesting() {
			return !this.rfidService.doesDeviceHaveNFC() || this.isStagingSite
		},
	},
	methods: {
		async startScanning() {
			this.scanningRfid = true;
			this.awaitingScan = true;
			this.shouldEmit = true;

			this.rfidService.once('rfid:scanned', ({rfid}) => {
				if(this.awaitingScan) {
					this.rfid = rfid
					this.awaitingScan = false
				}
			})
		},
		addFakeRFID() {
			this.rfid = 'rfid_test_' + Date.now()
			this.awaitingScan = false
		},
		complete() {
			this.$emit('onScannedRfid', this.rfid);
			this.resetState();
		},
		resetState() {
			this.rfid = '';
			this.scanningRfid = false
			this.awaitingScan = false
		},
		back() {
			this.resetState()
		},
	},
}
</script>

<style scoped>
.scan-rfid .loading-message {
	animation: pulse 1.65s infinite linear;
}

.grey-background {
	background: #666 !important;
}
</style>